import Tone from 'tone';
import {bulkUpdate} from 'utils/bulkUpdate.js';
import Effects from 'effects/Effects.js';
import {AbstractAudioParamParameter} from 'parameters/AbstractAudioParamParameter.js';

class Chebyshev extends Effects.Effect {
    constructor(sequencerEngine) {
        super("Chebyshev", () => new Tone.Chebyshev(1), sequencerEngine);
        this.effectNode.oversampling = 'none';
        this.orderParameter = new AbstractAudioParamParameter(
            'Order', this.effectNode, (o, x) => o.order = x, {
                min: 1,
                max: 100,
                unit: '',
                defaultValue: 1
            });
        this.registerParameter(this.orderParameter);
        this.updateInitialValues();
    }

    getJson(isPreset) {
        let json = super.getJson();
        json.order = this.effectNode.order;
        json.enabled = this.enabledParameter.get();
        json.wet = this.effectNode.wet.value;
        json.name = this.name;

        json = this.saveParameterToJson(
            json, 'orderParameter', this.orderParameter, isPreset);

        return json;
    }

    fromJson(json, isCopy) {
        let bulk = super.fromJson(json, isCopy);
        bulkUpdate(this.orderParameter, json.order, bulk);
        if (json.enabled) {
            this.enable(true);
        }
        this.setValue(json.value);

        return {
            ... bulk,
            ... this.loadParameterFromJson(
                json, 'orderParameter', this.orderParameter, isCopy)
        };
    }

    getEffectCopy(sequencerEngine=this.sequencerEngine, ignoreId=true) {
        var copy = new Chebyshev(sequencerEngine);
        copy.fromJson(this.getJson(), ignoreId);
        return copy;
    }
}

export default Chebyshev;
